import {_, React, observer, classNames, Popover2} from '@api'
import {useVipLocalStore, VipLocalStore} from '@modules/VipLocalStore'
import { IEditableFields, StoresInstance} from '@stores'
import {computed, observable, action, toJS} from 'mobx'
import {C8HierarchyStore, CatalogItemSidebarDetailsStore, FilterItemState, useCatalogItemSidebarDetailsStore} from '@modules'
import {Fragment, useContext} from 'react'
import {Button, MenuItem, Popover, Spinner, Position, Menu, MenuDivider} from '@blueprintjs/core'
import {KeyboardArrowRight} from '@material-ui/icons'
import * as css from './SeasonSelectorFilterHierarchyDropdownModal.css'
import {FieldTypes} from '@stores/index'
import {Tooltip2} from '@api'
import Tooltip from '@material-ui/core/Tooltip'

export const DEBUG_DETAILS_SEASON_SELECTOR = DEBUG && true
/// region Stores
export const SeasonSelectorHierarchyDropdownStoreContext = React.createContext<SeasonSelectorHierarchyDropdownStore>(undefined)
export const useSeasonSelectorHierarchyDropdownStore = () => useContext(SeasonSelectorHierarchyDropdownStoreContext)

export class SeasonSelectorHierarchyDropdownStore extends VipLocalStore {
  constructor(stores: StoresInstance, public details: CatalogItemSidebarDetailsStore) {
    super(stores)
    this.catalog.seasonSelectorsModal[`hierarchy_${details.sidebar.selectedPathIndex}`] = this
    this.c8hierarchy = new C8HierarchyStore(stores.catalog, details)
  }

  c8hierarchy: C8HierarchyStore
  get isOffline() {
    return this.details?.isOffline
  }

  @computed get views() {
    const {isOffline, visible, selectedIds} = this
    return isOffline ? visible : visible.filter(v => (_.includes(selectedIds, v.id)))
  }

  get dependencies() { return this.catalog.itemCreationWithDepends}

  get invalidFields() {
    const {details: {invalidFields}, dependencies} = this

    return dependencies.filter(f => f != 'merchSeason' && invalidFields[f] === false)
  }

  @computed get isValid() {
    return _.isEmpty(this.invalidFields)
  }

  get selectionStore() {
    const {c8hierarchy} = this
    return c8hierarchy?.catalogHierarchySelectionStore
  }

  get seasonsToNavToItem() {
    const data = this.details.itemDetailsStore?.data,
      {catalog: {seasonSelectorFields}} = this

    if (!data || _.isEmpty(seasonSelectorFields)) return []

    // If any of the season filters don't include this object, show the button
    return seasonSelectorFields.filter(({field: f}) => {
      // TODO: Need to add subcategories logic in the config.
      if (FieldTypes.collectionVersion == f) return false
      else return true
    }).filter(_.identity)
  }

  @computed get seasonsValueToNavToItem() {
    const {seasonsToNavToItem} = this,
      data = this.details.itemDetailsStore?.data,
      seasons = {}
    seasonsToNavToItem.map(({field}) => {
      if (FieldTypes.collectionVersion != field) {
        let val = _.get(data, `${field}.name`) ?? _.get(data, `${field}`)
        if (Array.isArray(val)) {
          val = val.map(v => _.get(v, 'name')).join(' | ')
        }
        if (val) {
          seasons[field] = val
        }
      }
    })
    return seasons
  }

  @computed get availableCollections() {
    const {vlp, details: {data}} = this
    if (!vlp?.hierarchy?.hasVlpHierarchy) return []

    const {plan, collection, subCategories, collectionVersion} = data

    const {selected, allAvailableCollections, availablePlans, availableCollectionsFor} = vlp.hierarchy

    console.log(toJS({plan, collection, subCategories, collectionVersion, selected, allAvailableCollections, availablePlans, availableCollectionsFor}, {recurseEverything: true}))
  }

  get groups() {
    // const {modal: {dropDownStore}} = this.details
    const {selectionStore} = this
    return selectionStore?.dropDownSelectionState?.groups
  }

  @computed get disabledItem() {
    const {c8hierarchy: {isFieldDisabledOnceInC8}, catalog: {hierarchyTopFieldDetails: {dependants}}} = this
    return _.find(dependants, d => isFieldDisabledOnceInC8(d))
  }

  @computed get enabledItems() {
    const {c8hierarchy: {collectionVersionByName, collectionIdsForVersion}} = this,
      {groups, isOffline, disabledItem} = this,
      selected = disabledItem && groups[disabledItem]?.selected,
      selectionNameValue = selected && (_.chain(Array.from(selected?.values())).first() as any).get('name').value(),
      enabledItems = (selectionNameValue && !isOffline) ? collectionIdsForVersion(selectionNameValue) : _.chain<any>(collectionVersionByName).values().flatten().value()

    return enabledItems || []
  }

  @computed get selectedIds(): string[] {
    const {groups} = this,
      {c8hierarchy: {path}} = this

    // console.log("toJS(this.groups::", toJS(this.groups));
    return _.chain(path).map(d => Array.from(!groups ? [] : groups[d]?.selected?.keys() ?? []).filter(_.identity)).flatten().compact().value() as string[]
  }

  findElem = (dList, c) => _.find(dList, (d) => (d.length > c.length) ? d.toLowerCase().includes(c.toLowerCase()) : c.toLowerCase().includes(d.toLowerCase()))

  /**
   * ???
   */
  @computed get resetElements() {
    const {c8hierarchy: {isFieldDisabledOnceInC8, path}} = this

    return _.chain(path).filter(p => {
      const {groups, isOffline} = this,
        selected = groups[p]?.selected,
        isDisabled = (isFieldDisabledOnceInC8(p) && !isOffline && selected?.size)

      return !isDisabled
    }).value()
  }

  @action selectHierarchyItem = (hierarchyList) => {
    const {c8hierarchy: {path}, catalog: {hasVlpHierarchy}} = this,
      {resetElements, selectionStore: {setDefaultSelectionState, setSelectionOnField, resetSelection}} = this

    DEBUG_DETAILS_SEASON_SELECTOR && console.debug(`selectHierarchyItem`, {setDefaultSelectionState, path})
    // console.log("Selection list:", hierarchyList)
    resetSelection(resetElements)
    hierarchyList.forEach(({id, name, type}) => {
      const item = _.find(path, (t) => type == t)
      if (item) {
        DEBUG_DETAILS_SEASON_SELECTOR && console.log("selectHierarchyItem - set value for ", id, name, type);
        setSelectionOnField(type, name ?? id, {id, exId: id, name})
      }
    })

    if (hasVlpHierarchy) {
      const {details: {data, data: {plan, subCategories, collection, collectionVersion}}, catalog: {vlp: {hierarchy: h}}} = this
      if (hierarchyList.some(v => v.type === 'collection')) {
        // Verify the collection version is correct and filled in
        if (collection?.id) {
          const c = h.collectionById[collection.id]
          if (c) {
            if (collectionVersion) {
             // Restrict it to the available one that best matches or null
             const cv = c.versions.find(v => v.name == collectionVersion.name)
              data['collectionVersion'] = _.pick(cv, ['name', 'id', 'exId'])
            }
            else {
              // Set the value if only one exists
              if (c.versions.length === 1) {
                data['collectionVersion'] = _.pick(_.first(c.versions), ['name', 'id', 'exId'])
              }
            }
          }
        }
      }
    }
  }

  @computed get visible() {
    const {c8hierarchy: {hierarchies: hierarchyData, topFieldName, isDataLoadedForField}, catalog: {hierarchyTopFieldDetails: {field}}} = this
    return isDataLoadedForField(topFieldName) ? (hierarchyData[field] ?? []) : []
  }

  /**
   * A series of <Fragment><name /><RightCaretIcon /><name/>etc</Fragment>
   */
  @computed get buttonInternalChildren() {
    const {groups} = this,
      {catalog: {seasonSelectorFields}, c8hierarchy: {path}, catalog: { hierarchyTopFieldDetails: {skipButtonText}}} = this,
      hierarchyNames = _.chain(path)
        .filter(p => skipButtonText ? !skipButtonText.includes(p) : !seasonSelectorFields.some(v => v.field === p && v.align === 'right'))
        .map(f => Array.from(!groups ? [] : groups[f]?.selected?.values() ?? []).filter(_.identity))
        .flatten()
        .map(({name}, i) => <span key={i} className={css.hierarchyName}>{name}</span>)
        .value()

    const r = hierarchyNames.map((t, i) => <Fragment key={i}>{t}{i < hierarchyNames.length - 1 ? <KeyboardArrowRight/> : null}</Fragment>) //.join(" -> ")
    return r
  }
}

/// endregion

/// region Components
/**
 * Renders a nested menu for navigating to a plan -> folder -> folder -> collection hierarchy or one like season -> category 1 -> category 2
 *
 * Generally passed the list of fields required to create an item in C8
 * @param fields
 * @constructor
 */
export const SeasonSelectorFilterHierarchyDropdownModal = observer<{ position?: Position }>(function SeasonSelectorFilterHierarchyDropdownModal({position}) {
  const sidebarDetailsStore = useCatalogItemSidebarDetailsStore(),
    store = useVipLocalStore((ws) => new SeasonSelectorHierarchyDropdownStore(ws, sidebarDetailsStore)),
    {
      selectedIds, isOffline, buttonInternalChildren,
      catalog: {hasLoadedConfig, itemCreationWithDepends: fields},
      c8hierarchy: {isDataLoadedForField, topFieldName},
      isValid, views, invalidFields, dependencies, seasonsToNavToItem, seasonsValueToNavToItem
    } = store

  // !isValid && console.log({seasonsToNavToItem, seasonsValueToNavToItem, invalidFields, dependencies})

  return hasLoadedConfig && !_.isEmpty(fields) && (
    <SeasonSelectorHierarchyDropdownStoreContext.Provider value={store}>
      <div className={css.root}>
        <Popover2
          interactionKind='hover'
          autoFocus={false}
          className={css.root}
          popoverClassName={css.menuPopover}
          position={position || 'bottom-left'}
          hoverCloseDelay={1}
          minimal
          content={isOffline && <Menu className={classNames(css.menu, css.modalMenu)}>
	         {/*<div className={css.invalidFields}>*/}
           {/*    {invalidFields.map(f => (*/}
           {/*      <div key={f} className={css.invalidField}>*/}
           {/*        <label>Required:</label>*/}
           {/*        <span className={css.field}>{labelForFieldName_currentCatalog(f)}</span>*/}
           {/*      </div>))}*/}
           {/*    */}
	         {/*</div>*/}

           {DEBUG && !_.isEmpty(invalidFields) && <Fragment>
             {invalidFields.map((f, i) => (<UnspecifiedHierarchyFieldMenuItem key={i} field={f} />))}
	           <MenuDivider/>
           </Fragment>}

	         <HierarchyMenuItems items={views} selected={selectedIds}/>
         </Menu>}>
          {/*<Tooltip disableHoverListener={isValid} disableFocusListener={isValid} title={invalidHierarchyTooltip} placement='bottom-start'>*/}
            <span>
              <Button
                data-valid={isValid}
                data-offline={isOffline}
                minimal
                className={classNames(css.button, css.buttonText)}
                text={
                  <span className={css.buttonContents}>
                    {!isDataLoadedForField(topFieldName) ? <Spinner size={14}/> : _.isEmpty(buttonInternalChildren) ? <span className={css.hierarchyName}>Choose a {_.startCase(topFieldName)}...</span> : buttonInternalChildren}
                  </span>
                }
                rightIcon={!isDataLoadedForField(topFieldName) ? undefined : 'caret-down'}/>
              </span>
          {/*</Tooltip>*/}
        </Popover2>
      </div>
    </SeasonSelectorHierarchyDropdownStoreContext.Provider>)
})

export const UnspecifiedHierarchyFieldMenuItem = observer<{field: string }>(function UnspecifiedHierarchyFieldMenuItem({field: fieldName}) {
    const {catalog: {labelForFieldName_currentCatalog}, details: {data}, availableCollections} = useSeasonSelectorHierarchyDropdownStore()

  return null

  // console.log(toJS({data, fieldName}))
  //
  // return (<MenuItem icon='blank' text={labelForFieldName_currentCatalog(fieldName)}>
  //     List of flattened full paths based on available selection
  // </MenuItem>)
})

const HierarchyMenuItems = observer<{ selected?: string[], items: Array<any>, parent?, type? }>(function HierarchyMenuItems({selected, items, type, parent}) {
  const store = useSeasonSelectorHierarchyDropdownStore(),
    {
      strings, findElem, selectHierarchyItem, isOffline, enabledItems, disabledItem,
      catalog: {perspective, hierarchyTopFieldDetails: {field, hierarchyElements, dependants}}
    } = store

  if (!items?.length) {
    return <MenuItem text='No Items'/>
  }
  return <Fragment>
    {items.map(item => {
      const {id, name} = item,
        [child] = _.intersection(Object.keys(item), hierarchyElements),
        children = child && item[child],
        newParent = [
          ...(parent ?? []),
          {id, name, type: (item.type && findElem(dependants, item.type) || (item.type == 'MerchFolder' && 'subCategories')) || type || field}
        ],
        views = isOffline ? children : children?.filter(c => (_.includes(selected, c.id) || !!perspective?.itemEdit?.editable?.filter((edit: IEditableFields) => edit.type === c.type)))

      // console.log(toJS(item), child, newParent, toJS(children))
      return ((parentDetails) => {
        return item.type != 'MerchCollection' && children ?
               (<MenuItem key={id} className={css.menuItem}
                          icon={selected.includes(name) ? 'tick' : 'blank'}
                          text={`${name}`}>
                 <HierarchyMenuItems items={views} selected={selected} parent={newParent} type={child && findElem(dependants, child)}/>
               </MenuItem>)
                                                          : _.isEmpty(disabledItem) ?
                                                            (<MenuItem key={id}
                                                                       icon={selected.includes(id) ? 'tick' : 'blank'}
                                                                       className={css.menuItem} onClick={() => selectHierarchyItem(parentDetails)}
                                                                       text={`${name}`}/>) :
                                                            (enabledItems.includes(id) ?
                                                             (<MenuItem key={id}
                                                                        icon={selected.includes(id) ? 'tick' : 'blank'}
                                                                        className={css.menuItem} onClick={() => selectHierarchyItem(parentDetails)}
                                                                        text={`${name}`}/>) :
                                                             (<Tooltip2 key={id}
                                                                        content={strings.noMerchProductVersionAvailable}>
                      <span>
                        <MenuItem
                          icon={selected.includes(id) ? 'tick' : 'blank'}
                          className={css.menuItem}
                          disabled
                          text={`${name}`}/>
                      </span>
                                                             </Tooltip2>)
                                                            )
      })([...newParent])
    })}
  </Fragment>
})

/// endregion



// WEBPACK FOOTER //
// ./src/modules/siteHeader/components/SeasonSelectorFilterHierarchyDropdownModal.tsx